import * as React from "react";
import { ChangePassword } from "../../auth/ChangePassword";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "../../components/ui/dialog";

export const PasswordChangeform = (): React.ReactElement => {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          size="default"
          variant="outline"
          className="w-fit hidden"
          data-change-password
        >
          Change Password
        </Button>
      </DialogTrigger>
      <DialogContent>
        <ChangePassword onSuccessCallBack={handleClose} />
      </DialogContent>
    </Dialog>
  );
};
